import React from "react";
import { BrainIcon, GiftIcon, HeartIcon, PaletteIcon, PrinterIcon } from "lucide-react";
import { heroBenefits, images, price } from "../data/landing";
import { CtaButton } from "./CtaButton";
const icons = {
  palette: PaletteIcon,
  brain: BrainIcon,
  printer: PrinterIcon,
  heart: HeartIcon,
  gift: GiftIcon
};
export function Hero() {
  return <section className="mx-auto grid max-w-6xl gap-8 px-5 pb-12 pt-8 md:grid-cols-[1.1fr_1fr] md:gap-12 md:pt-12 lg:pb-16" data-id="element-81" data-mp="4njq6ckn7zc1">
      <div className="md:sticky md:top-6 md:self-start" data-id="element-82" data-mp="xae8b2tzmmmc">
        <img src={images.hero} alt="Portada del MegaPack Arteterapia con +50 técnicas en tablet, junto a plantillas de rueda de emociones, laberinto e iceberg" className="w-full rounded-3xl object-cover shadow-[0_20px_50px_-25px_rgba(94,43,151,0.35)]" data-id="element-83" data-mp="xaxg3qpxbumn" />
      </div>

      <div className="flex flex-col gap-5" data-id="element-84" data-mp="3d33fj0i70xlt">
        <div data-id="element-85" data-mp="382p73hcojln9">
          <h1 className="font-display text-3xl font-bold leading-tight text-plum sm:text-4xl lg:text-[2.75rem]" data-id="element-86" data-mp="381xiwrlewq70">
            MegaPack Arteterapia +50 Técnicas
          </h1>
          <p className="mt-3 font-display text-xl leading-snug text-ink sm:text-2xl" data-id="element-87" data-mp="3o7lrboupx2nw">
            Una forma creativa y práctica de explorar lo que sientes, expresarlo y conectar contigo
          </p>
        </div>

        <p className="text-lg leading-relaxed text-muted" data-id="element-88" data-mp="3e963buqzm9im">
          Una colección completa de ejercicios creativos para trabajar emociones, calma, autoconocimiento y bienestar
          desde casa.
        </p>

        <div className="rounded-2xl bg-paper px-5 py-4 shadow-sm" data-id="element-89" data-mp="358zr0c70zfl1">
          <p className="text-sm font-extrabold uppercase tracking-wide text-muted" data-id="element-90" data-mp="2qjv7mrohv5bc">Hoy por solo</p>
          <p className="font-display text-4xl font-bold text-plum" data-id="element-91" data-mp="2viy1rh2xrr4j">{price}</p>
          <p className="mt-1 text-sm text-muted" data-id="element-92" data-mp="2vj7wtj2u8oh3">Pago único mediante Mercado Pago · Acceso al material digital</p>
        </div>

        <ul className="flex flex-col gap-2" data-id="element-93" data-mp="2lkqwhvi0exid">
          {heroBenefits.map(b => {
          const Icon = icons[b.icon];
          return <li key={b.text} className="flex items-start gap-3 rounded-lg bg-lilac/60 px-3 py-2.5 text-[15px] text-ink" data-id="element-94" data-mp="s2tdvmncibq9">
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-plum" aria-hidden="true" data-id="element-95" data-mp="n98bzjimsxls" />
                {b.text}
              </li>;
        })}
        </ul>

        <CtaButton label="¡Quiero mi MegaPack de Arteterapia!" data-id="element-96" data-mp="degeefp1uar0" />
      </div>
    </section>;
}